import { StickyNote } from "lucide-react"
import { Knot } from "../utils/query"


export type TimelineKnotViewProps = {
    index?: number
    maxLen?: number
    knotRef?: ((node: HTMLElement | null) => void) | null
    knot: Knot
}


export const TimelineKnotView = (props:TimelineKnotViewProps) => {
    const knot = props.knot

    return (
        <li ref={props.knotRef ?? undefined}>
            {/*props.index !== 0 && <hr />*/}
            <hr />
            <div className="timeline-middle">
                <StickyNote size={16} />
            </div>
            <div className="timeline-end mb-10">
                <time className="font-mono italic">{knot.timestamp}</time>
                <div className="text-lg font-black">{knot.title}</div>
                {knot.description}
            </div>
            {((props.index ?? 0) + 1) !== props.maxLen  && <hr />}
        </li>
    )
}

export default TimelineKnotView